<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
          <ul>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='success'>
          {{success}}
        </div>
        <!-- <div class='col-lg-4 col-sm-4' style="padding: 10px">
          <span>التاريخ:</span>
          <input  @keypress="isLocked($event)" :value='record.date' class='form-control' name='notes' type='text'>
        </div> -->

        <div class='col-lg-4 col-sm-4' style="padding: 10px 5px 0px">
          <div class="form-group input-group">
            <span class="input-group-addon">الغرض</span>
            <select class="form-control" style="padding: 0px" v-model="record.call_type_id">
              <option v-for="item in callTypes" v-bind:key="item.id" v-bind:value="item.id">
                {{item.name}}
              </option>
            </select>
          </div>
        </div>
        <div class='col-lg-3 col-sm-3' style="padding: 10px 5px 0px">
          <div class="form-group input-group">
            <span class="input-group-addon">الحالة</span>
            <select class="form-control" style="padding: 0px" v-model="record.call_status_id">
              <option v-for="item in callStatus" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class='col-lg-3 col-sm-3' style="padding: 10px 0px 0px">
          <div class="form-group input-group" style='margin: 2px;'>
            <span class="input-group-addon">الاجراء</span>
            <select class="form-control" style="padding: 0px" v-model="record.action_id">
              <option v-for="item in callActions" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class='col-lg-2 col-sm-2' style="padding: 10px 5px 0px">
          <div class="form-group input-group">
            <span class="input-group-addon">التأجيل</span>
            <select class="form-control" style="padding: 0px" v-model="record.call_delay">
              <option v-for="item in 30" :value="item -1 " v-bind:key="item" >
                {{ item -1 }}
              </option>
            </select>
          </div>
        </div>
        <div class='col-lg-12 col-sm-12' style="padding: 0px 5px">
          <span>ملاحظات:</span>
          <textarea class="form-control" rows="4" v-model="record.notes"></textarea>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 10px;  text-align:center;'>
          <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
          <button v-show="$per.value.saveReceipt" @click='showForm(0)'  type='button' class='btn btn-primary btn-outline btn-sm'>جديد</button>
          <button v-show="($per.value.saveReceipt && record.id === 0 )" @click='saveData'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
          <!-- <button v-show="record.id > 0 " @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-sm'>حذف</button> -->
        </div>
          <div class="chat-panel panel panel-default">
              <div class="panel-body" style="padding: 5px">
                <div class="scrollable-table-container">
                  <table class="compact-table">
                    <thead>
                      <tr>
                        <th style='text-align: center'>التاريخ</th>
                        <th style='text-align: center'>الوقت</th>
                        <th style='text-align: center'>الغرض</th>
                        <th style='text-align: center'>الحالة</th>
                        <th style='text-align: center'>الاجراء</th>
                        <th style='text-align: center'>المستخدم</th>
                      </tr>
                    </thead>
                    <tbody v-if="!$per.value.editReceipt">
                      <tr v-for='record in records' :key='record.id'>
                        <td style="padding:2px" align='center'>{{record.date}}</td>
                        <td style="padding:2px" align='center'>{{record.time}}</td>
                        <td style="padding:2px" align='center'>{{record.call_type}}</td>
                        <td style="padding:2px" align='center'>{{record.call_status}}</td>
                        <td style="padding:2px" align='center'>{{record.call_action}}</td>
                        <td style="padding:2px" align='center'>{{record.user_name}}</td>
                      </tr>
                    </tbody>
                    <tbody  v-if="$per.value.editReceipt">
                      <tr :class="{highlight :selectedrec == record.id}"  v-for='record in records' :key='record.id' v-on:click="showForm(record)">
                        <td style="padding:2px" align='center'>{{record.date}}</td>
                        <td style="padding:2px" align='center'>{{record.time}}</td>
                        <td style="padding:2px" align='center'>{{record.call_type}}</td>
                        <td style="padding:2px" align='center'>{{record.call_status}}</td>
                        <td style="padding:2px" align='center'>{{record.call_action}}</td>
                        <td style="padding:2px" align='center'>{{record.user_name}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
          </div>
        <!-- /.col-lg-6 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import API from '@/store/api'
import Swal from 'sweetalert2'
export default {
  name: 'CustomerCalls',
  data () {
    return {
      records: [],
      record: {},
      validationErrors: '',
      success: '',
      id: '',
      selectedrec: null,
      callTypes: JSON.parse(localStorage.getItem('call_types') || '[]'),
      callActions: JSON.parse(localStorage.getItem('call_actions') || '[]'),
      callStatus: JSON.parse(localStorage.getItem('call_statuses') || '[]'),
      successShow: false,
      isLoadingSave: false,
      isLoadingData: false,
      isLoadingDelete: false
    }
  },
  methods: {
    // =====================================================
    async pageLoad (id) {
      this.id = id
      this.isLoadingData = true
      try {
        const data = await API.getCustomerCalls({
          id: id
        })
        this.records = data
      } catch (err) {
        this.records = []
      }
      this.isLoadingData = false
    },
    // =====================================================
    isLocked (evt) {
      evt.preventDefault()
    },
    // =====================================================
    isNumber (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // =====================================================
    showForm (recID) {
      var userID = JSON.parse(localStorage.getItem('main_data'))
      var today = new Date()
      var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      if (recID === 0) {
        this.record = {'id': 0, 'customer_id': '', 'call_type_id': '', 'call_status_id': '', 'action_id': '', 'call_delay': 0, 'notes': '', 'time': '', 'user_name': userID[0].value, 'date': date}
      } else {
        this.record = recID
      }
      this.successShow = false
      this.selectedrec = recID.id
    },
    // =====================================================
    async saveData () {
      this.isLoadingSave = true
      try {
        this.record.customer_id = this.id
        const data = await API.saveCustomerCalls(
          this.record
        )
        this.records = data
        this.selectedrec = 0
        this.isLoadingSave = false
        this.success = 'تم الحفظ بنجاح'
      } catch (err) {
        this.validationErrors = err.errors
        this.isLoadingSave = false
      }
    },
    // =====================================================
    async deleteData (id) {
      const result = await Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })

      if (result.isConfirmed) {
        this.successShow = false
        this.isLoadingDelete = true
        try {
          await API.deleteCustomerCalls({
            id: id
          })
          let i = this.records.map(record => record.id).indexOf(this.record.id)
          this.records.splice(i, 1)
          this.selectedrec = 0
          this.isLoadingDelete = false
          Swal.fire({
            position: 'fixed',
            icon: 'success',
            title: 'تم حذف السجل بنجاح',
            showConfirmButton: false,
            timer: 1000
          })
        } catch (err) {
          this.validationErrors = err.errors
          this.isLoadingDelete = false
        }
      }
    }
    // =====================================================
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Customers/CustomerCalls.vue